import { ApiResponse, ApiDataResponse } from "./Dtos";
import { AxiosInstance } from "axios";

export class ApiService<T> {
  protected axiosClient: AxiosInstance;
  protected baseUrl: string;

  constructor(baseUrl: string, axiosClient: AxiosInstance) {
    this.baseUrl = baseUrl;
    this.axiosClient = axiosClient;
  }

  async getAll(): Promise<ApiDataResponse<T>> {
    const response = await this.axiosClient.get<ApiDataResponse<T>>(
      this.baseUrl
    );
    return response.data;
  }

  async getById(id: string): Promise<ApiDataResponse<T>> {
    const response = await this.axiosClient.get<ApiDataResponse<T>>(
      `${this.baseUrl}/${id}`
    );
    return response.data;
  }

  async create(data: T): Promise<ApiDataResponse<T>> {
    const response = await this.axiosClient.post<ApiDataResponse<T>>(
      this.baseUrl,
      data
    );
    return response.data;
  }

  async update(id: string, data: T): Promise<ApiResponse> {
    const response = await this.axiosClient.put<ApiResponse>(
      `${this.baseUrl}/${id}`,
      data
    );
    return response.data;
  }

  async delete(id: string): Promise<ApiResponse> {
    const response = await this.axiosClient.delete<ApiResponse>(
      `${this.baseUrl}/${id}`
    );
    return response.data;
  }
}
